import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { CondoCorporation } from '@models/matter';
import {
	CondoCorporationsSearchState,
	CondoCorporationDispatch,
} from '@state/algolia-search/condo-corporations-search';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

export enum DropdownSelect {
	SELECT_CONDO_CORPORATION = 'SelectCondoCorporation',
}

@UntilDestroy()
@Component({
	selector: 'app-search-condo-corporation-input',
	templateUrl: './search-condo-corporation.component.html',
	standalone: false,
})
export class SearchCondoCorporationComponent implements OnInit {
	public condoCorporationName = '';
	public ICON = ICON;
	public showDropdown = false;
	public loading = false;
	public dropdownSelect = DropdownSelect;

	@Input() label = '';

	@Output() onFocus = new EventEmitter();
	@Output() onCreate = new EventEmitter<string>();
	@Output() onSelect = new EventEmitter();

	@Select(CondoCorporationsSearchState.getList) condoCorporations$: Observable<
		CondoCorporation[]
	>;

	ngOnInit() {
		combineLatest([this.condoCorporations$])
			.pipe(
				untilDestroyed(this),
				map(() => {
					this.loading = false;
				}),
			)
			.subscribe();
	}

	constructor(private condoCorporationSearch: CondoCorporationDispatch) {}

	search = ($event) => {
		this.loading = true;
		this.condoCorporationSearch.Search($event);
	};

	_onFocus() {
		this.onFocus.emit();
	}

	create() {
		this.onCreate.emit(this.condoCorporationName);
	}

	onSelectCondoCorporation = (ev: DropdownResult<CondoCorporation>) => {
		if (ev.groupType === DropdownSelect.SELECT_CONDO_CORPORATION) {
			this.onSelect.emit(ev.result);
		}
	};
}
